"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudySubjectWithIpCodes = exports.StudyExternalApiCaptureQueue = exports.StudyExternalApiCaptureItem = exports.StudyExternalApiCapturePage = exports.StudyExternalApiCaptureStatus = exports.StudyExternalApiAuthTokenDestroyedReason = exports.StudyExternalApiAuthToken = void 0;
class StudyExternalApiAuthToken {
}
exports.StudyExternalApiAuthToken = StudyExternalApiAuthToken;
var StudyExternalApiAuthTokenDestroyedReason;
(function (StudyExternalApiAuthTokenDestroyedReason) {
    StudyExternalApiAuthTokenDestroyedReason["Expired"] = "EXPIRED";
    StudyExternalApiAuthTokenDestroyedReason["SignOut"] = "SIGN_OUT";
    StudyExternalApiAuthTokenDestroyedReason["NewToken"] = "NEW_TOKEN";
})(StudyExternalApiAuthTokenDestroyedReason = exports.StudyExternalApiAuthTokenDestroyedReason || (exports.StudyExternalApiAuthTokenDestroyedReason = {}));
var StudyExternalApiCaptureStatus;
(function (StudyExternalApiCaptureStatus) {
    StudyExternalApiCaptureStatus["Requested"] = "REQUESTED";
    StudyExternalApiCaptureStatus["Processing"] = "PROCESSING";
    StudyExternalApiCaptureStatus["Done"] = "DONE";
    StudyExternalApiCaptureStatus["Failed"] = "FAILED";
})(StudyExternalApiCaptureStatus = exports.StudyExternalApiCaptureStatus || (exports.StudyExternalApiCaptureStatus = {}));
class StudyExternalApiCapturePage {
}
exports.StudyExternalApiCapturePage = StudyExternalApiCapturePage;
class StudyExternalApiCaptureItem {
}
exports.StudyExternalApiCaptureItem = StudyExternalApiCaptureItem;
class StudyExternalApiCaptureQueue {
}
exports.StudyExternalApiCaptureQueue = StudyExternalApiCaptureQueue;
class StudySubjectWithIpCodes {
}
exports.StudySubjectWithIpCodes = StudySubjectWithIpCodes;
//# sourceMappingURL=studyExternalApi.js.map